import React, { useEffect } from "react";
import CardGrey from "../components/CardGrey";
import { useMediaPredicate } from "react-media-hook";
import DarkRedButton from "../components/DarkRedButton";
import CardWhite from "../components/CardWhite";
import { getAllPhotos, getSingleImage } from "../utils/Helpers";
import { Parallax } from "react-scroll-parallax";
import management1 from "../Images/management-hero-a-1x.webp";
import management2 from "../Images/management-hero-b-1x.webp";

import { motion } from "framer-motion";
export default function Management({
  handleCurrentPage,
  slide_right,
  slide_left,
}) {
  const max_width = useMediaPredicate("(max-width: 760px)");
  const max_width2 = useMediaPredicate("(max-width: 1230px)");
  const headshotImgs = ["lisa_s", "joshua_p"];

  useEffect(() => {
    handleCurrentPage();
    getAllPhotos("management");
    window.scroll(0, 0);

    for (let x of headshotImgs) {
      getSingleImage(`team/headshots/${x}.webp`, x);
    }
  }, []);
  useEffect(() => {
    window.dataLayer.push({
      event_name: "pageview",
      page: {
        title: "Management Page",
      },
    });
  }, []);

  return (
    <div className="management-container">
      <Parallax speed={max_width2 ? 0 : -3}>
        <motion.div {...slide_right} className="management-hero">
          <p className="management-hero-sub">Galerie management</p>
          <h1 className="management-hero-title">
            Galerie Living's Premier Community Operator
          </h1>
        </motion.div>
      </Parallax>

      <div className="capital-block-1 management-block-1">
        <img
          src={management1}
          alt="Exterior of Corso Atlanta Senior Living Building"
          className="capital-block-1-img"
          id={
            max_width
              ? "management-block-1a-img-mobile"
              : "management-block-1a-img"
          }
        />
        <img
          src={management2}
          alt="A rot iron fence at Corso Atlanta covered in flowering vines."
          className="capital-block-1-img"
          id={
            max_width
              ? "management-block-1b-img-mobile"
              : "management-block-1b-img"
          }
        />
      </div>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="management-offset-block mob-1">
          <motion.p {...slide_right} className="management-offset-text1">
            At the core of our approach, we seek to inspire happiness, preserve
            dignity, embrace innovation, and achieve excellence in everything we
            do.
          </motion.p>
          <motion.p {...slide_left} className="management-offset-text2">
            In each of our communities, we promote success by investing in our
            spaces, people, technology, and services - establishing a healthy,
            sustainable senior-living-ecosystem.
          </motion.p>
        </div>
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <img
          className="management-block-2-img"
          loading="lazy"
          id={
            max_width
              ? "management-block-2-img-mobile"
              : "management-block-2-img"
          }
          alt="Two residents walking down a hallway with their dog."
        />
      </Parallax>

      <Parallax translateY={[150, 0]} easing={[0.25, 1, 0.25, 1]}>
        <div className="management-text-block">
          <h1>
            Creating <span style={{ color: "#aa8c2c" }}>more good days</span>{" "}
            for seniors, families, and communities
          </h1>
        </div>
      </Parallax>

      <div className="our-leaders">
        <p className="our-leaders-title">Our Leaders</p>
        <Parallax
          translateY={max_width2 ? [0, 0] : [40, 0]}
          easing={[0.25, 1, 0.25, 1]}
        >
          <div className="leaders-card">
            <img
              loading="lazy"
              className="leaders-image"
              alt="President of Galerie Management, Joshua Peterson head shot"
              id="joshua_p"
            />
            <div className="leaders-body">
              <h1 className="leaders-name">Joshua Peterson</h1>
              <p className="leaders-title">President of galerie management</p>
              <p className="leaders-bio">
              With more than 15 years of experience in the senior living space, Joshua started his career as a nurse in the Tampa area.  Joshua’s compassion and expertise inevitably led him into becoming a Regional Director of Operations and  has since moved into the top leadership role in Galerie Management as he successfully and seamlessly intertwines hospitality and wellness.
              </p>
            </div>
          </div>
        </Parallax>
        <Parallax
          translateY={max_width2 ? [0, 0] : [40, 0]}
          easing={[0.25, 1, 0.25, 1]}
        >
          <div className="leaders-card">
            <img
              loading="lazy"
              className="leaders-image"
              alt="VP of Operations, Lisa Swafford Head shot"
              id="lisa_s"
            />
            <div className="leaders-body">
              <h1 className="leaders-name">Lisa Swafford</h1>
              <p className="leaders-title">
                VP of Operations
              </p>
              <p className="leaders-bio">
                With over 20 years of experience in the senior living industry,
                Lisa Swafford uses her deep understanding of consumer needs to
                drive growth throughout the southeastern market. Graduating with
                a degree in Gerontology and Interpersonal Communications, she
                uses her insights and experience to lead a team dedicated to
                educating, supporting, and guiding residents and families
                through the decision making process.
              </p>
            </div>
          </div>
        </Parallax>
        <div className="management-our-team-btn-div">
          <DarkRedButton
            btnLink="/team"
            btnText="our team"
            class_name="management-our-team-btn"
            data_test_id="management-our-team-btn"
          />
        </div>
      </div>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <CardWhite
          imgId={"management-card-1-img"}
          cardTitle={"World Class Service"}
          cardText={
            "Our award winning communities deliver the best in class service expected from premier, luxury senior living communities. Through our collaboration with Forbes Travel Guide and commitment to excellence, all of our residents and guests are greeted and supported by outstanding associates."
          }
          cardText2="With our in-house training and Galerie Rewards Program, we’re able to attract and retain top-tier talent."
          buttonShown={false}
          class_name={"management-card-1"}
          alt_tag="A Galerie Living employee smiling and waving in front of a Corso Senior Living building."
        />
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="management-block-3">
          <img
            loading="lazy"
            alt="The spa inside of Corso Atlanta."
            className="management-block-3-img"
            id={
              max_width
                ? "management-block-3a-img-mobile"
                : "management-block-3a-img"
            }
          />
          <img
            loading="lazy"
            alt="Two residents showing their paintings after a paint class at Corso Atlanta."
            className="management-block-3-img"
            id={
              max_width
                ? "management-block-3b-img-mobile"
                : "management-block-3b-img"
            }
          />
        </div>
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="management-offset-block mob-2">
          <motion.p {...slide_right} className="management-offset-text1">
            Galerie communities feature complete assisted living licensing
            across all of our apartments and city homes - even for independent
            residents. Our unique Adaptive Care licensing model allows
            independent residents to gradually, seamlessly, and discreetly
            receive new support and care services in their same
            independent-style residence - allowing our residents to develop
            lasting relationships with their neighbors and caregivers in a home
            that suits their needs.
          </motion.p>
          <motion.p {...slide_right} className="management-offset-text2">
            Our streamlined integration of all-in-one senior living operations
            platform Fynn empowers our caregivers with always-up-to-date
            information and proactive solutions, while promoting transparency
            between caregivers, residents, and loved ones.
          </motion.p>
        </div>
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="management-card-2">
          <p className="management-card-2-text">
            Fynn utilizes AI-powered, information-backed load balancing to
            create efficient workflows for our caregivers that adapts to the
            dynamic nature of resident ADL completion. By taking some of the
            burden off our caregivers, our communities become rewarding,
            supportive work environments that boost retention and create more
            good days for our associates - not just our residents.
          </p>
          <img
            loading="lazy"
            alt="A nurse holding a card that says Fynn.io."
            className="management-card-2-img"
            id={
              max_width
                ? "management-card-2-img-mobile"
                : "management-card-2-img"
            }
          />
        </div>
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="card-grey management-card-grey">
          <img
            loading="lazy"
            alt="A resident painting in an art class at Corso Atlanta."
            className="card-grey-img"
            id={
              max_width
                ? "management-card-3-img-mobile"
                : "management-card-3-img"
            }
          />
          <div className="card-grey-body">
            <h2 className="card-grey-body-title">Flourish</h2>
            <p className="card-grey-body-text">
              Successful aging is the ultimate goal of all of our care
              initiatives, and our Flourish program achieves this through three
              distinct levels designed to promote independence while gradually
              adding the desired level of support for residents' needs. Flourish
              Enrich is designed for active adults and organized by a Resident
              Experience Coordinator. These daily enrichment activities include
              holistic therapies, support groups, resident experiences, and
              preventative wellness programs. Flourish Engage is a tailored
              program designed for small groups of residents with acute memory
              loss. Here, residents will find supplemental assistance for their
              memory loss journey while still cherishing engaging experiences.
              Flourish Enclave acts as a part of our memory care program,
              offering dignified experiences that are adapted to adhere to our
              residents’ cognitive and physical abilities.
            </p>
            <DarkRedButton
              class_name="card-grey-button"
              btnText={"Learn More"}
              btnLinkExternal={"https://corsoatlanta.com/wellness/#flourish"}
              btnWidth={""}
              data_test_id="management-flourish-btn"
            />
          </div>
        </div>
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="management-block-3">
          <img
            loading="lazy"
            alt="A chef cooking at the bakery at Corso Atlanta Senior Living."
            className="management-block-3-img"
            id={
              max_width
                ? "management-block-4a-img-mobile"
                : "management-block-4a-img"
            }
          />
          <img
            loading="lazy"
            alt="A gourmet dinner at the restaurant at Corso Atlanta Senior Living."
            className="management-block-3-img"
            id={
              max_width
                ? "management-block-4b-img-mobile"
                : "management-block-4b-img"
            }
          />
        </div>
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="management-offset-block mob-3">
          <motion.p {...slide_right} className="management-offset-text1">
            To deliver on quality, experiential dining services, we’ve partnered
            with world-class chefs to create luxurious and sustainable menus
            that feature a wide variety of cuisines.
          </motion.p>
          <motion.p {...slide_left} className="management-offset-text2">
            We’ve established relationships with local farmers to use fresh,
            healthy, and sustainable ingredients in our made-from-scratch,
            signature dishes. 
          </motion.p>
        </div>
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="management-block-3">
          <img
            loading="lazy"
            alt="A Corso resident and grandchild gardening together."
            className="management-block-3-img"
            id={
              max_width
                ? "management-block-5a-img-mobile"
                : "management-block-5a-img"
            }
          />
          <img
            loading="lazy"
            alt="A Corso resident sitting on the couch with her dog."
            className="management-block-3-img"
            id={
              max_width
                ? "management-block-5b-img-mobile"
                : "management-block-5b-img"
            }
          />
        </div>
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="management-offset-block mob-4">
          <motion.p {...slide_right} className="management-offset-text1">
            With decades of experience in the industry, our senior living
            consultants bolster occupancy by nurturing qualified referral
            sources, recognizing weaknesses and opportunities in the market, and
            capitalizing on Galerie properties’ abilities to address needs that
            other communities cannot.
          </motion.p>
          <motion.p {...slide_left} className="management-offset-text2">
            Our teams leverage Fynn’s comprehensive lead tracking systems to
            identify, monitor, and propel conversions from the very first
            inquiry. All of our consultants are empowered by a wealth of
            accurate, up-to-date and actionable data on current leads and
            conversion trends, allowing them to efficiently allocate resources
            and recognize fruitful channels.
          </motion.p>
        </div>
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <CardGrey
          imgId={
            max_width ? "management-card-4-img-mobile" : "management-card-4-img"
          }
          cardTitle={"Marketing Strategies"}
          cardText={
            "Our marketing team is at the forefront of showcasing the extraordinary experiences found in Galerie communities. Through thoughtful and elegant marketing strategies, we captivate discerning seniors and families who value storied, exceptional senior living."
          }
          cardText2={
            "Our approach combines stunning imagery, compelling storytelling, and personalized engagement to create a seamless journey that resonates with both prospective families and established community members. A strong digital presence, data-driven insights, and a commitment to forward thinking propel Galerie's fruitful campaigns"
          }
          class_name={"management-card-4"}
          buttonShown={false}
          alt_tag="Two employees of Galerie Living looking at designs and patterns."
        />
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <CardGrey
          imgId={"management-card-capital-img"}
          cardTitle={"Galerie Capital"}
          cardText={
            "At Galerie Capital, we believe that our dedication to delivering superior risk-adjusted returns, our commitment to being a steward of capital, our focused, high-quality portfolio, our creative investor-centric approach, and our operational excellence are what set us apart in the real estate investment space. We invite you to learn more about Galerie Capital and our approach to real estate investing."
          }
          buttonLink={"/capital"}
          class_name={"capital-card-grey cap-card-white"}
          flexStyle="row-reverse"
          data_test_id="management-view-capital-btn"
          alt_tag="Three investors talking at Corso Atlanta."
        />
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : [150, 0]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <CardGrey
          imgId={"management-card-development-img"}
          cardTitle={"Galerie Development"}
          cardText={
            "Our team strategically identifies viable markets based on analysis of market demographics, migratory, traffic patterns, neighborhood amenities, community characteristics, and growth potential. We build strong partnerships with our general contractors and designers to create cutting edge communities reflective of their surrounding neighborhoods."
          }
          buttonLink={"/development"}
          class_name={"capital-card-grey"}
          data_test_id="management-view-development-btn"
          alt_tag="A woman in a pink hard hat looking at a blueprint."
        />
      </Parallax>
    </div>
  );
}
